namespace TabAurous.OMS {
    export interface MarkUpPolicyRow {
        MarkUpPolicyId?: number;
        MarkUpPolicyCode?: string;
        MarkUpPolicyName?: string;
        Charges?: MarkupChargesRow[];
    }

    export namespace MarkUpPolicyRow {
        export const idProperty = 'MarkUpPolicyId';
        export const nameProperty = 'MarkUpPolicyCode';
        export const localTextPrefix = 'OMS.MarkUpPolicy';
        export const lookupKey = 'OMS.MarkUpPolicy';

        export function getLookup(): Q.Lookup<MarkUpPolicyRow> {
            return Q.getLookup<MarkUpPolicyRow>('OMS.MarkUpPolicy');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            MarkUpPolicyId = "MarkUpPolicyId",
            MarkUpPolicyCode = "MarkUpPolicyCode",
            MarkUpPolicyName = "MarkUpPolicyName",
            Charges = "Charges"
        }
    }
}
